function StatsCard({ title, data, icon }) {
    return (
        <div className="flex items-center justify-around gap-5 p-10 bg-white shadow-md rounded-xl w-52 md:w-96">
            {icon}
            <div className="flex flex-col items-start justify-center gap-4">
                <h4 className="text-sm font-semibold md:text-lg text-gray-color-primary">
                    {title}
                </h4>
                <p className="text-sm font-medium md:text-md text-blue-color-light">
                    {data}
                </p>
            </div>
        </div>
    );
}

export default StatsCard;
